<template>
  <modal
    name="formularioEdit"
    height="auto"
    width="90%"
    :scrollable="true"
    :clickToClose="false"
  >
    <CloseModal :close="close" />
    <div class="modalbox">
      <div class="modalbox-content">
        <CTabs variant="tabs" class="nav-tabs-boxed">
          <CTab title="Cabeçalho do Formulário">
            <div class="xrow">
              <div class="col-1-3">
                <div class="form-group">
                  <label>Título</label>
                  <input class="form-control" v-model="formulario.titulo" />
                </div>
              </div>

              <div v-if="context === 'LGPD'" class="col-1-3">
                <div class="form-group">
                  <label>Slug</label>
                  <input class="form-control" v-model="formulario.slug" />
                </div>
              </div>

              <div v-if="context === 'LGPD'" class="col-1-3">
                <div class="form-group">
                  <label>Tipo</label>
                  <select class="form-control" v-model="formulario.tipo">
                    <option hidden>Selecione</option>
                    <option value="ACESSO_DADOS_PESSOAIS">
                      ACESSO_DADOS_PESSOAIS
                    </option>
                    <option value="INCIDENTE_DADOS_PESSOAIS">
                      INCIDENTE_DADOS_PESSOAIS
                    </option>
                  </select>
                </div>
              </div>

              <div v-if="context === 'PESQUISA'" class="col-1-3">
                <div class="form-group">
                  <label>Data de Início</label>
                  <datetime
                    input-class="form-control"
                    v-model="formulario.dataInicio"
                    type="date"
                    :phrases="{ ok: 'Confirmar', cancel: 'Fechar' }"
                    value-zone="local"
                  />
                </div>
              </div>

              <div v-if="context === 'PESQUISA'" class="col-1-3">
                <div class="form-group">
                  <label>Data de Fim</label>
                  <datetime
                    input-class="form-control"
                    v-model="formulario.dataFim"
                    type="date"
                    :phrases="{ ok: 'Confirmar', cancel: 'Fechar' }"
                    value-zone="local"
                  />
                </div>
              </div>

              <div class="col-1-3" v-if="context === 'PESQUISA'">
                <div class="form-group">
                  <label>Preenchimento obrigatório</label>
                  <select class="form-control" v-model="formulario.obrigatorio">
                    <option :value="1">Sim</option>
                    <option :value="0">Não</option>
                  </select>
                </div>
              </div>

              <div class="col-1-3" v-if="context === 'PESQUISA'">
                <div class="form-group">
                  <label>Local de Exibição</label>
                  <select class="form-control" v-model="formulario.local">
                    <option hidden>Selecione</option>
                    <option value="INICIO_ORCAMENTO">
                      Início do Orçamento
                    </option>
                    <option value="FIM_ORCAMENTO">Finalizar o Pedido</option>
                  </select>
                </div>
              </div>

              <div class="col-1-3" v-if="context === 'PESQUISA'">
                <div class="form-group">
                  <label>Preenchimento Único</label>
                  <select
                    class="form-control"
                    v-model="formulario.respostaUnica"
                  >
                    <option :value="1">Sim</option>
                    <option :value="0">Não</option>
                  </select>
                </div>
              </div>

              <div v-if="context === 'PESQUISA'" class="col-1-3">
                <div class="form-group">
                  <label>Imagem no Cabeçalho</label>
                  <image-picker
                    id="imagem-cabecalho"
                    v-model="formulario.imagem"
                    placeholder="Colar URL ou clique ao lado para upload"
                  />
                </div>
              </div>

              <div class="col-1-1">
                <div class="form-group">
                  <label for="descricao">Descrição</label>
                  <EditorConteudo id="descricao" :item="formulario" />
                </div>
              </div>

            </div>
            <label v-if="context === 'LGPD'" class="alert-text">
              Somente disponível no VersoCommerce
            </label>
            <label v-if="context === 'PESQUISA'" class="alert-text">
              Somente disponível no Força de Vendas
            </label>
          </CTab>

          <CTab title="Perguntas">
            <PerguntasBase
              :perguntas="formulario.perguntas"
              :formulario="formulario"
            />
          </CTab>

          <CTab v-if="context ===  'PESQUISA'" title="Restrições">
            <Restricao :item="formulario" validation="validation" />
          </CTab>
        </CTabs>
      </div>
    </div>

    <div class="modal-footer">
      <div class="xrow">
        <div class="col-1-1">
          <button
            type="button"
            class="button button-success pull-right"
            @click="handleSubmit"
            :disabled="loading"
          >
            <strong>Salvar</strong>
          </button>
        </div>
      </div>
    </div>
  </modal>
</template>

<script>
import CloseModal from "@/components/CloseModal";
import PerguntasBase from "./PerguntasBase.vue";
import EditorConteudo from "@/components/EditorConteudo.vue";
import ImagePicker from "@/components/ImagePicker.vue";
import Restricao from "@/views/RegraNegocio/components/components/Restricao/Restricao.vue";
import { post, put } from "@/helpers/apiRequest";

export default {
  name: "FormularioEditBase",
  components: {
    CloseModal,
    PerguntasBase,
    EditorConteudo,
    ImagePicker,
    Restricao,
  },
  props: {
    close: Function,
    formulario: Object,
    context: {
      type: String,
      required: true,
      validator: (val) => ["LGPD", "PESQUISA"].includes(val),
    },
  },
  data() {
    return {
      loading: false,
    };
  },
  methods: {
    handleSubmit() {
      this.loading = true;

      const data = {
        ...this.formulario,
        descricao: this.formulario.conteudo,
        dataInicio: this.formulario.dataInicio?.split("T")[0] || null,
        dataFim: this.formulario.dataFim?.split("T")[0] || null,
      };

      if (this.context === "PESQUISA") {
        data.tipo = "ORCAMENTO";
        data.acessafv = 1;
      } else {
        data.acessab2b = 1;
      }

      const payload = { ...data };
      delete payload.conteudo;

      const request = this.formulario.id
        ? put(`/admin/formularios/formulario/${this.formulario.id}`, data)
        : post("/admin/formularios/formulario", payload);

      request
        .then(() => {
          this.$swal({
            title: "Sucesso!",
            text: this.formulario.id
              ? "Formulário atualizado com sucesso!"
              : "Formulário criado com sucesso!",
            icon: "success",
          });
          this.close();
        })
        .catch((err) => {
          this.$swal({
            title: "Erro!",
            text: err.message || err.error || "Falha ao salvar o formulário.",
            icon: "error",
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
  watch: {
    "formulario.descricao"(val) {
      this.formulario.conteudo = val;
    },
  },
};
</script>

<style scoped>
.alert-text {
  color: red;
}
</style>
